import { render, staticRenderFns } from "./customQueryLogic.vue?vue&type=template&id=79ca669e&"
import script from "./customQueryLogic.vue?vue&type=script&lang=js&"
export * from "./customQueryLogic.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "pc/bhc/query/customQueryLogic.vue"
export default component.exports